import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { Device } from 'src/features/parkingStatus/types';
import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/devices/';

interface DTO extends ListDTO {
    parkingId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<Device>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...params }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, params],
        queryFn: async () => await queryFn(params),
        ...config,
    });
};

export { RESOURCE as LIST_DEVICES_RESOURCE, queryFn as listDevices, useQueryHook as useListDevices };
export type { DTO as ListDevicesDTO };
